import { useState, useEffect, useRef } from "react";
import "../../styles/website/Home.css";
import "../../styles/website/AboutUs.css";
import "../../styles/website/Earn.css";
import Layout from "../website/component/Layout";

/* =========================================================
   آیکون‌های خطی (SVG) — هماهنگ با تم پروژه
   ========================================================= */

const IconPhone = () => (
  <svg viewBox="0 0 24 24" fill="none">
    <rect
      x="7"
      y="2"
      width="10"
      height="20"
      rx="2.2"
      stroke="currentColor"
      strokeWidth="1.7"
    />
    <path
      d="M10.7 18.3H13.3"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
    />
  </svg>
);

const IconStore = () => (
  <svg viewBox="0 0 24 24" fill="none">
    <path
      d="M4 10V20H20V10"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3 10L5 4H19L21 10"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3 10C3 11.7 4.3 13 6 13C7.7 13 9 11.7 9 10C9 11.7 10.3 13 12 13C13.7 13 15 11.7 15 10C15 11.7 16.3 13 18 13C19.7 13 21 11.7 21 10"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
    />
  </svg>
);

const IconCard = () => (
  <svg viewBox="0 0 24 24" fill="none">
    <rect
      x="2.5"
      y="5.5"
      width="19"
      height="13"
      rx="2.2"
      stroke="currentColor"
      strokeWidth="1.7"
    />
    <path d="M2.5 9.5H21.5" stroke="currentColor" strokeWidth="1.7" />
    <path
      d="M6 14.5H10"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
    />
  </svg>
);

const IconWallet = () => (
  <svg viewBox="0 0 24 24" fill="none">
    <path
      d="M3 7.5C3 6.1 4.1 5 5.5 5H17C18.7 5 20 6.3 20 8V8.5"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
    />
    <path
      d="M3 7.5V17C3 18.4 4.1 19.5 5.5 19.5H18.5C19.9 19.5 21 18.4 21 17V10C21 8.6 19.9 7.5 18.5 7.5H5.5C4.1 7.5 3 6.4 3 5"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinejoin="round"
    />
    <circle
      cx="16.5"
      cy="13.5"
      r="1.3"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </svg>
);

const IconGlobe = () => (
  <svg viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.7" />
    <path
      d="M3 12H21M12 3C14.5 5.7 15.8 8.7 15.8 12C15.8 15.3 14.5 18.3 12 21C9.5 18.3 8.2 15.3 8.2 12C8.2 8.7 9.5 5.7 12 3Z"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinejoin="round"
    />
  </svg>
);

const IconClock = () => (
  <svg viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.7" />
    <path
      d="M12 7V12L15.5 14"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const IconShieldCheck = () => (
  <svg viewBox="0 0 24 24" fill="none">
    <path
      d="M12 3l7 3v6c0 4.5-3 7.5-7 9-4-1.5-7-4.5-7-9V6l7-3z"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinejoin="round"
    />
    <path
      d="M9 12l2 2 4-4"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const IconInfinity = () => (
  <svg viewBox="0 0 24 24" fill="none">
    <path
      d="M7 9C4.8 9 3 10.8 3 13S4.8 17 7 17C9.5 17 10.7 15.3 12 13C13.3 10.7 14.5 9 17 9C19.2 9 21 10.8 21 13S19.2 17 17 17C14.5 17 13.3 15.3 12 13C10.7 10.7 9.5 9 7 9Z"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinejoin="round"
    />
  </svg>
);

const IconCoins = () => (
  <svg viewBox="0 0 24 24" fill="none">
    <ellipse
      cx="8"
      cy="7"
      rx="5"
      ry="3"
      stroke="currentColor"
      strokeWidth="1.6"
    />
    <path
      d="M3 7V14C3 15.7 5.2 17 8 17C10.8 17 13 15.7 13 14V7"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
    />
    <path
      d="M3 10.5C3 12.2 5.2 13.5 8 13.5C10.8 13.5 13 12.2 13 10.5"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
    />
    <ellipse
      cx="16"
      cy="12"
      rx="5"
      ry="3"
      stroke="currentColor"
      strokeWidth="1.6"
    />
    <path
      d="M11 12V17C11 18.7 13.2 20 16 20C18.8 20 21 18.7 21 17V12"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
    />
  </svg>
);

const IconPulse = () => (
  <svg viewBox="0 0 24 24" fill="none">
    <path
      d="M3 12H7L9.5 5L14 19L16.5 12H21"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/* =========================================================
   داده‌ها
   ========================================================= */

const toFa = (n) => n.toLocaleString("fa-IR");

const REFERRAL_UNIT_INCOME = 1_100_000; // میانگین پورسانت به‌ازای هر معرفی موفق (تومان)
const CALC_MIN = 5;
const CALC_MAX = 60;
const CALC_STEP = 5;
const CALC_DEFAULT = 45;

const INCOME_TIERS = [
  {
    level: "شروع‌کننده",
    referrals: "۱۰ معرفی در ماه",
    income: "۱۱ میلیون تومان",
    note: "کنار هر شغل دیگه‌ای، در وقت آزاد",
  },
  {
    level: "فعال",
    referrals: "۳۰ معرفی در ماه",
    income: "۳۳ میلیون تومان",
    note: "روزی ۱ معرفی، بدون فشار",
    highlight: true,
  },
  {
    level: "حرفه‌ای",
    referrals: "۶۰+ معرفی در ماه",
    income: "۶۶ میلیون تومان +",
    note: "سقفی وجود نداره",
  },
];

const HOW_STEPS = [
  {
    icon: <IconPhone />,
    title: "ثبت شماره موبایل",
    text: "شماره مشتری رو وارد می‌کنی، کد تأیید براش ارسال میشه.",
  },
  {
    icon: <IconStore />,
    title: "اطلاعات فروشگاه",
    text: "اطلاعات فروشگاه، تم و قالب مورد نظر انتخاب میشه.",
  },
  {
    icon: <IconCard />,
    title: "پرداخت آنلاین",
    text: "مشتری شماره کارتش رو می‌زنه، پرداخت در لحظه انجام میشه.",
  },
  {
    icon: <IconWallet />,
    title: "پورسانت فوری",
    text: "همون لحظه ۱۰٪ مستقیم وارد کیف پول تو میشه.",
  },
];

const WHY_US = [
  {
    icon: <IconGlobe />,
    title: "بدون محدودیت مکانی",
    text: "خونه، مسافرت، جمع دوستان — هر جا باشی کار می‌کنه.",
  },
  {
    icon: <IconClock />,
    title: "۲۴ ساعته، ۷ روز هفته",
    text: "هیچ ساعت کاری‌ای نداری. هر وقت خواستی درآمد داری.",
  },
  {
    icon: <IconShieldCheck />,
    title: "پشتیبانی کامل با ماست",
    text: "تو فقط پورسانت می‌گیری. تمام پشتیبانی با شرکته.",
  },
  {
    icon: <IconInfinity />,
    title: "بدون سقف درآمد",
    text: "هر چقدر بیشتر معرفی کنی، بیشتر درآمد داری.",
  },
];

const MONEY_FLOW = [
  { icon: <IconStore />, title: "مشتری پرداخت می‌کنه" },
  { icon: <IconPulse />, title: "سیستم پورسانت رو محاسبه می‌کنه" },
  { icon: <IconWallet />, title: "۱۰٪ فوری وارد کیف پولت میشه" },
  { icon: <IconCoins />, title: "تسویه به حساب بانکی، زیر ۲۴ ساعت" },
];

/* =========================================================
   ساب‌کامپوننت‌ها
   ========================================================= */

function TierCard({ tier, index }) {
  return (
    <div
      className={`earn-tier-card ${tier.highlight ? "earn-tier-card-highlight tile-dark" : "tile"} reveal`}
      style={{ "--d": `${index * 0.1}s` }}
    >
      {tier.highlight && <span className="earn-tier-badge">پیشنهاد ما</span>}
      <span className="earn-tier-level">{tier.level}</span>
      <span className="earn-tier-income">{tier.income}</span>
      <span className="earn-tier-referrals">{tier.referrals}</span>
      <p className="earn-tier-note">{tier.note}</p>
    </div>
  );
}

function TicketStep({ step, index, total }) {
  return (
    <div className="earn-ticket-step">
      <div className="earn-ticket-step-inner tile">
        <span className="earn-ticket-step-num">
          {toFa(index + 1).padStart(2, "۰")}
        </span>
        <span className="earn-ticket-step-icon">{step.icon}</span>
        <h4>{step.title}</h4>
        <p>{step.text}</p>
      </div>
      {index < total - 1 && (
        <span className="earn-ticket-perf" aria-hidden="true" />
      )}
    </div>
  );
}

/* بخش «مزایا» — بدون کادر/جعبه: چیدمان باز با آیکون دایره‌ای و
   جداکننده‌ی نازک به‌جای پس‌زمینه‌ی tile-dark */
function WhyTile({ icon, title, text, index }) {
  return (
    <div className="earn-why-tile reveal" style={{ "--d": `${index * 0.08}s` }}>
      <div className="earn-why-icon">{icon}</div>
      <h3>{title}</h3>
      <p>{text}</p>
    </div>
  );
}

function FlowStep({ icon, title, index }) {
  return (
    <div className="earn-flow-step reveal" style={{ "--d": `${index * 0.1}s` }}>
      <div className="earn-flow-step-num">{icon}</div>
      <h4>{title}</h4>
    </div>
  );
}

/* ---------- Hero: محاسبه‌گر درآمد (عنصر امضادار این صفحه) ---------- */

function IncomeCalculator() {
  const [referrals, setReferrals] = useState(CALC_DEFAULT);
  const income = referrals * REFERRAL_UNIT_INCOME;

  const pct = ((referrals - CALC_MIN) / (CALC_MAX - CALC_MIN)) * 100;

  return (
    <div className="earn-calc-card tile-dark">
      <div className="earn-calc-top">
        <span className="earn-calc-title">محاسبه‌گر درآمد</span>
        <span className="earn-calc-live">
          <span className="earn-calc-dot" /> زنده
        </span>
      </div>

      <div className="earn-calc-amount">
        <span className="earn-calc-amount-num">{toFa(income)}</span>
        <span className="earn-calc-amount-unit">تومان در ماه</span>
      </div>

      <label className="earn-calc-slider-label" htmlFor="referral-range">
        چند نفر رو در ماه به دُکانا معرفی می‌کنی؟
      </label>
      <input
        id="referral-range"
        type="range"
        min={CALC_MIN}
        max={CALC_MAX}
        step={CALC_STEP}
        value={referrals}
        onChange={(e) => setReferrals(Number(e.target.value))}
        className="earn-calc-slider"
        style={{ "--pct": `${pct}%` }}
      />
      <div className="earn-calc-slider-scale">
        <span>{toFa(CALC_MIN)} نفر</span>
        <span className="earn-calc-slider-current">{toFa(referrals)} نفر</span>
        <span>{toFa(CALC_MAX)}+ نفر</span>
      </div>

      <div className="earn-calc-breakdown">
        <div className="earn-calc-breakdown-item">
          <span>{toFa(REFERRAL_UNIT_INCOME)} ت</span>
          <label>پورسانت هر معرفی</label>
        </div>
        <div className="earn-calc-breakdown-sep" />
        <div className="earn-calc-breakdown-item">
          <span>&lt; ۲۴ ساعت</span>
          <label>تسویه به حساب</label>
        </div>
      </div>
    </div>
  );
}

/* =========================================================
   کامپوننت اصلی
   ========================================================= */

export default function Earn() {
  const revealRef = useRef(null);

  useEffect(() => {
    const reduceMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)",
    ).matches;
    const targets = document.querySelectorAll(".reveal");

    let observer;
    if ("IntersectionObserver" in window && !reduceMotion) {
      observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) entry.target.classList.add("in-view");
          });
        },
        { threshold: 0.22 },
      );
      targets.forEach((el) => observer.observe(el));
    } else {
      targets.forEach((el) => el.classList.add("in-view"));
    }

    return () => observer && observer.disconnect();
  }, []);

  return (
    <Layout>
      {/* ---------- Hero: بدون استفاده از الگوی شاپ‌کارت هوم/درباره‌ما ---------- */}
      <section className="earn-hero" ref={revealRef}>
        <div className="wrap earn-hero-grid">
          <div className="earn-hero-text">
            <h1>
              کنار هر شغلی که داری، <span className="accent">روزی چند نفر</span>{" "}
              رو معرفی کن
            </h1>
            <p className="earn-hero-sub">
              با محدودیت اینترنت و افت شبکه‌های اجتماعی، فروشگاه‌ساز دُکانا
              بهترین موقعیت ممکنه. برای هرکسی فروشگاه اختصاصی بساز که همیشه روی
              اینترنت داخلی کار می‌کنه، و ۱۰٪ پورسانتش رو همون لحظه بگیر.
            </p>
            <div className="hero-actions">
              <a href="/panel/login" className="btn btn-primary btn-lg">
                همین الان شروع کن
              </a>
            </div>
          </div>

          <div className="earn-hero-visual" id="calc-start">
            <IncomeCalculator />
          </div>
        </div>
      </section>

      {/* ---------- Money flow ---------- */}
      <section className="earn-flow">
        <div className="wrap">
          <div className="section-head">
            <div>
              <h2>همون لحظه پرداخت، پورسانت تو واریز میشه</h2>
            </div>
          </div>
          <div className="earn-flow-stepper">
            {MONEY_FLOW.map((step, i) => (
              <FlowStep
                key={step.title}
                {...step}
                index={i}
                total={MONEY_FLOW.length}
              />
            ))}
          </div>
        </div>
      </section>

      {/* ---------- Income tiers ---------- */}
      <section className="earn-tiers">
        <div className="wrap">
          <div className="section-head">
            <div>
              <h2>ببین دیگران چقدر درآمد دارن</h2>
            </div>
          </div>
          <div className="earn-tiers-grid">
            {INCOME_TIERS.map((tier, i) => (
              <TierCard key={tier.level} tier={tier} index={i} />
            ))}
          </div>
        </div>
      </section>

      {/* ---------- Why us ---------- */}
      <section className="why-now">
        <div className="wrap">
          <div className="section-head">
            <div>
              <h2>مزایایی که جای دیگه‌ای پیدا نمی‌کنی</h2>
            </div>
          </div>
          <div className="earn-why-grid">
            {WHY_US.map((tile, i) => (
              <WhyTile key={tile.title} {...tile} index={i} />
            ))}
          </div>
        </div>
      </section>

      {/* ---------- Final CTA (glass) ---------- */}
      <section className="about-cta">
        <div className="wrap about-cta-wrap">
          <div className="cta-glow cta-glow-1" aria-hidden="true" />
          <div className="cta-glow cta-glow-2" aria-hidden="true" />
          <div className="glass-cta">
            <h2>آماده‌ای شروع کنی؟</h2>
            <p>
              همین الان قدم اول رو بردار — اولین فروشگاه رو ثبت کن و ۱۰٪ پورسانت
              رو آنی دریافت کن.
            </p>
            <div className="about-cta-actions">
              <a href="/panel/login" className="btn btn-primary btn-lg">
                شروع کن
              </a>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}
